/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_Accessible_Skip_NavInputs */

const en_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip navigation to main content`)
};

const de_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip-Navigation zum Hauptinhalt`)
};

const fr_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer la navigation au contenu principal`)
};

const es_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saltar navegacion al contenido principal`)
};

const it_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salta la navigazione al contenuto principale`)
};

const nl_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigatie overslaan naar hoofdinhoud`)
};

const pl_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeskocz nawigacje do glownej tresci`)
};

const fi_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ohita navigaatio pääsisältöön`)
};

const da_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spring navigation over til hovedindhold`)
};

const sv_a11y_statement_accessible_skip_nav = /** @type {(inputs: A11y_Statement_Accessible_Skip_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoppa over navigering till huvudinnehall`)
};

/**
* | output |
* | --- |
* | "Skip navigation to main content" |
*
* @param {A11y_Statement_Accessible_Skip_NavInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_accessible_skip_nav = /** @type {((inputs?: A11y_Statement_Accessible_Skip_NavInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_Accessible_Skip_NavInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_accessible_skip_nav(inputs)
	if (locale === "fr") return fr_a11y_statement_accessible_skip_nav(inputs)
	if (locale === "es") return es_a11y_statement_accessible_skip_nav(inputs)
	if (locale === "it") return it_a11y_statement_accessible_skip_nav(inputs)
	if (locale === "nl") return nl_a11y_statement_accessible_skip_nav(inputs)
	if (locale === "pl") return pl_a11y_statement_accessible_skip_nav(inputs)
	if (locale === "fi") return fi_a11y_statement_accessible_skip_nav(inputs)
	if (locale === "da") return da_a11y_statement_accessible_skip_nav(inputs)
	if (locale === "sv") return sv_a11y_statement_accessible_skip_nav(inputs)
	return en_a11y_statement_accessible_skip_nav(inputs)
});